import { createAsyncThunk } from '@reduxjs/toolkit'
import apiRequest from '../../lib/http'

const messageFrom = (error, fallback) =>
  error.response?.data?.error?.errors?.[0]?.message || fallback

export const loadWebhookCatalogue = createAsyncThunk(
  'webhookSubscriptions/catalogue',
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiRequest.get('/webhooks/catalogue')
      return response.data.data
    } catch (error) {
      return rejectWithValue(messageFrom(error, 'Failed to load the webhook catalogue'))
    }
  }
)

export const loadWebhooks = createAsyncThunk(
  'webhookSubscriptions/list',
  async ({ groupId }, { rejectWithValue }) => {
    try {
      const response = await apiRequest.get(`/contact-groups/${groupId}/webhooks`)
      return response.data.data
    } catch (error) {
      return rejectWithValue(messageFrom(error, 'Failed to load webhooks'))
    }
  }
)

export const createWebhook = createAsyncThunk(
  'webhookSubscriptions/create',
  async ({ groupId, payload }, { rejectWithValue }) => {
    try {
      const response = await apiRequest.post(`/contact-groups/${groupId}/webhooks`, payload)
      return response.data.data
    } catch (error) {
      return rejectWithValue(messageFrom(error, 'Failed to create the webhook'))
    }
  }
)

export const updateWebhook = createAsyncThunk(
  'webhookSubscriptions/update',
  async ({ groupId, id, payload }, { rejectWithValue }) => {
    try {
      const response = await apiRequest.put(`/contact-groups/${groupId}/webhooks/${id}`, payload)
      return response.data.data
    } catch (error) {
      return rejectWithValue(messageFrom(error, 'Failed to save the webhook'))
    }
  }
)

export const deleteWebhook = createAsyncThunk(
  'webhookSubscriptions/delete',
  async ({ groupId, id }, { rejectWithValue }) => {
    try {
      const response = await apiRequest.delete(`/contact-groups/${groupId}/webhooks/${id}`)
      return response.data.data
    } catch (error) {
      return rejectWithValue(messageFrom(error, 'Failed to remove the webhook'))
    }
  }
)

export const rotateWebhookKey = createAsyncThunk(
  'webhookSubscriptions/rotateKey',
  async ({ groupId, id }, { rejectWithValue }) => {
    try {
      const response = await apiRequest.post(`/contact-groups/${groupId}/webhooks/${id}/rotate-key`)
      return response.data.data
    } catch (error) {
      return rejectWithValue(messageFrom(error, 'The key could not be rotated'))
    }
  }
)

export const testWebhook = createAsyncThunk(
  'webhookSubscriptions/test',
  async ({ groupId, id }, { rejectWithValue }) => {
    try {
      const response = await apiRequest.post(`/contact-groups/${groupId}/webhooks/${id}/test`)
      return response.data.data
    } catch (error) {
      return rejectWithValue(messageFrom(error, 'The test send could not be made'))
    }
  }
)

export const loadWebhookDeliveries = createAsyncThunk(
  'webhookSubscriptions/deliveries',
  async ({ groupId, id }, { rejectWithValue }) => {
    try {
      const response = await apiRequest.get(`/contact-groups/${groupId}/webhooks/${id}/deliveries`)
      return response.data.data
    } catch (error) {
      return rejectWithValue(messageFrom(error, 'Failed to load the delivery log'))
    }
  }
)

export const replayWebhookDelivery = createAsyncThunk(
  'webhookSubscriptions/replay',
  async ({ groupId, id, deliveryId }, { rejectWithValue }) => {
    try {
      const response = await apiRequest.post(
        `/contact-groups/${groupId}/webhooks/${id}/deliveries/${deliveryId}/replay`
      )
      return response.data.data
    } catch (error) {
      return rejectWithValue(messageFrom(error, 'The event could not be sent again'))
    }
  }
)
